<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte de ingresos por doctor</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_05_DR</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Generación de reporte de ingresos por doctor
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>

      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(generar)">

          <b-row>
            <b-col>
              <b-row align-v="center" align-h="end">

                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                         v-model="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                         v-model="filtro.fechaFin"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="clinica" :rules="{ required: true }" v-slot="validationContext">
                    <label>Clinica:<validacion/></label>
                    <b-container>
                      <b-row style="width: 100%">
                        <b-col cols="11">
                          <v-select style="width: 100%" :options="listaClinicas"
                                    v-model="filtro.clinica"
                                    :reduce="(variable) => variable.idClinica"
                                    label="nombreClinica" placeholder="Selecciona una clínica" multiple>
                            <span slot="no-options">No hay clínicas disponibles</span>
                          </v-select>
                        </b-col>
                        <b-col cols="1">
                          <b-button
                              class="ml-1"
                              variant="outline-primary"
                              v-b-tooltip.hover
                              title="Seleccionar Todos"
                              @click="seleccionarTodasClinicas()">
                            <b-icon icon="check2-all"></b-icon>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-container>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <label>Doctor:</label>
                  <validation-provider name="doctores" :rules="{ required: false }" v-slot="errors">
                    <b-form-group>
                      <v-select style="width: 100%" :options="listaDoctores"
                                v-model="filtro.doctor" :reduce="(variable) => variable.id"
                                label="nombre" placeholder="Selecciona un doctor" multiple>
                        <span slot="no-options">No hay doctores disponibles</span>
                      </v-select>
                      <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
                    </b-form-group>
                  </validation-provider>
                </b-col>


                <b-col align="right">
                  <b-button v-b-tooltip.hover title="Generar reporte" variant="outline-success"
                            type="submit" :disabled="loader">Generar
                  </b-button>
                </b-col>

              </b-row>
            </b-col>
          </b-row>

        </b-form>
      </validation-observer>

      <div class="mt-2 col-md-12"></div>

      <div align="center" v-if="loader">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>

      <b-row>
        <b-col cols="12" v-for="tabla in datosTabla" v-bind:key="tabla">
          <div class="table-responsive-true">
            <table class="table b-table b-table-fixed b-table-caption-top">

            <thead role="rowgroup">
              <tr role="row" class="columnas">
                <th role="columnheader" scope="col" class="table-b-table-default" rowspan="2">{{tabla.doctor}}</th>
                <template v-for="mes in tabla.datosMeses">
                  <th role="columnheader" scope="col" class="table-b-table-default" :key="mes.numeroMes" colspan="2">{{mes.nombreMes}}</th>
                </template>
                <th role="columnheader" scope="col" class="table-b-table-default" rowspan="2">Total ingreso</th>
                <th role="columnheader" scope="col" class="table-b-table-default" rowspan="2">Total traspaso</th>
                <th role="columnheader" scope="col" class="table-b-table-default" rowspan="2">Gran total</th>
              </tr>
              <tr role="row" class="">
                <template v-for="mes in tabla.datosMeses">
                  <th role="columnheader" scope="col" class="table-b-table-default" :key="mes.numeroMes+'ing'">Ingreso</th>
                  <th role="columnheader" scope="col" class="table-b-table-default" :key="mes.numeroMes+'trasp'">Traspaso</th>
                </template>
              </tr>
            </thead>

            <tbody role="rowgroup">
              <template v-for="clinica in tabla.datosClinica">
                <tr :key="clinica.nombreClinica" class="" role="row">
                  <td :key="clinica.nombreClinica" class="" role="cell">{{ clinica.nombreClinica }}</td>
                  <template v-for="mes in clinica.datosMeses">
                    <td :key="mes.ingreso" class="" role="cell">{{mes.ingreso|moneda}}</td>
                    <td :key="mes.traspaso" class="" role="cell">{{mes.traspaso|moneda}}</td>
                  </template>
                  <td :key="clinica.totalIngreso" class="" role="cell">{{ clinica.totalIngreso|moneda }}</td>
                  <td :key="clinica.totalTraspaso" class="" role="cell">{{ clinica.totalTraspaso|moneda }}</td>
                  <td :key="clinica.granTotal" class="" role="cell">{{ clinica.granTotal|moneda }}</td>
                </tr>
              </template>
            </tbody>

            <tfoot>
              <td>Totales</td>
              <template v-for="mes in tabla.datosMeses" >
                <td :key="mes.numeroMes">{{mes.ingreso|moneda}}</td>
                <td :key="mes.numeroMes">{{mes.traspaso|moneda}}</td>
              </template>
              <td>{{ tabla.totalIngreso|moneda }}</td>
              <td>{{ tabla.totalTraspaso|moneda }}</td>
              <td>{{ tabla.granTotal|moneda }}</td>
            </tfoot>

          </table>
          </div>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";

export default {
  components: {
    Header
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      datosTabla: [],
      paginaActual: 1,
      loader: false,
      filtro: {
        fechaInicio: null,
        fechaFin: null,
        clinica: null,
        doctor: null,
      },
      listaClinicas: [],
      listaDoctores: []
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.llenarClinicas();
    this.llenarDoctoresClinica();
  },
  watch: {
    "filtro.clinica": function() {
      this.filtro.doctor= null;
      if(this.filtro.clinica === null) {
        this.listaDoctores= [];
      } else {
        this.listaDoctores= [];
        this.filtro.clinica.forEach(it => {
          if (it instanceof Object) {
            this.llenarDoctoresClinica(it.idClinica);
          } else {
            this.llenarDoctoresClinica(it);
          }
        });
      }
    }
  },
  methods: {
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },
    llenarDoctoresClinica(idClinica) {
      const parametros = {
        idClinica: idClinica
      }
      this.$http.post(this.$api + "diagnostico/hoja/listaDoctoresClinicaAgendaDoc", parametros)
          .then(response => {
            if (response.status === 200) {
              this.listaDoctores = this.listaDoctores.concat(response.data.data.map(it => {
                return {
                  id: it.idEmpleado,
                  nombre: it.nombreEmpleado
                };
              }).filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i));
            }
          })
          .catch(error => {
            this.loadingDoctores=false;
            console.error(error);
          }).finally(()=>this.loadingDoctores=false);
    },
    seleccionarTodasClinicas() {
      this.filtro.clinica = this.listaClinicas;
    },
    generar() {
      this.loader = true;
      this.datosTabla = [];

      const idsClinica = []
      this.filtro.clinica.forEach(it=>{
        if (it instanceof Object) {
          idsClinica.push(it.idClinica);
        } else {
          idsClinica.push(it);
        }
      });

      const filtro = {
        fechaInicio: this.filtro.fechaInicio !== null ? this.$moment(this.filtro.fechaInicio).format("YYYY-MM-DD") : null,
        fechaFin: this.filtro.fechaFin !== null ? this.$moment(this.filtro.fechaFin).format("YYYY-MM-DD") : null,
        clinica: idsClinica,
        doctor: this.filtro.doctor
      };

      this.$http.post(this.$api + 'reportes/ingresos/doctor', filtro).then(respuesta => {
        if (respuesta.data.data) {
          this.datosTabla = respuesta.data.data.ingresosPorDoctor;
        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 1;
      })
    }
  }
}
</script>

<style scoped>

</style>
